export class WidgetBoxContentMessageClasses {

    /**
     * Style applied to the root div of the widget box content.
     */
    static root = "ic3WidgetBoxContentMessage-root";
    /**
     * Style applied to the div containing the message.
     */
    static content = "ic3WidgetBoxContentMessage-content";
}

export declare type WidgetBoxContentMessageClassKey = keyof WidgetBoxContentMessageClasses;
